export default __webpack_public_path__ + "f209ca811786c289b28ad7d21855e603.svg";